import React, { useState, useEffect } from 'react';
import './RotatingText.css';

const RotatingText = ({ words, className = '' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <span className={`rotating-text-container ${className}`}>
      {words.map((word, index) => (
        <span
          key={index}
          className={`rotating-word ${index === currentIndex ? 'active' : ''}`}
        >
          {word}
        </span>
      ))}
    </span>
  );
};

export default RotatingText;
